export default "__VITE_ASSET__DgGLmP_a__"